import {useCallback, useContext, useEffect, useState} from 'react'

export const useCurrentListHandler = (
  currentList,
  {saveFunction, popFunction, pushFunction}
) => {
  const [currentListState, setCurrentListState] = useState(currentList)
  useEffect(() => {})
  const changeCurrentListState = useCallback(
    (item) => {
      const items = currentListState.items

      if (items.includes(item)) {
        setCurrentListState({
          ...currentListState,
          items: items.filter((i) => i !== item),
        })
        popFunction(item)
      } else {
        setCurrentListState({...currentListState, items: [...items, item]})
        pushFunction(item)
      }
      console.log(currentList, 'currentList')
    },
    [currentList, currentListState, popFunction, pushFunction]
  )

  const save = (currentListState) => {
    saveFunction(currentListState)
  }

  return [changeCurrentListState, save, currentListState]
}
